import {NavigationItem} from "./navigation-item.interface";

export const DESKTOP_PRIMARY_NAV_ITEMS: ReadonlyArray<NavigationItem> = [
  {
    labelKey: "DASHBOARD",
    route: "/",
    icon: "home",
    iconClasses:
      "block w-[28px] h-[28px] bg-black dark:bg-white mr-2 mask-[url(/assets/images/icons/home.svg)] mask-size-[28px_28px]",
  },
  {
    labelKey: "MY_WORKS",
    route: "/history",
    icon: "works",
    iconClasses:
      "block w-[28px] h-[28px] bg-black dark:bg-white mr-2 mask-[url(/assets/images/icons/works.svg)] mask-size-[28px_28px]",
  },
  {
    labelKey: "UPCOMING_RELEASES_MENU",
    route: "/upcoming-releases",
    icon: "calendar",
    iconClasses:
      "block w-[28px] h-[28px] bg-black dark:bg-white mr-2 mask-[url(/assets/images/icons/calendar.svg)] mask-size-[28px_28px]",
  },
  {
    labelKey: "LATEST_RELEASES",
    route: "/latest-releases",
    icon: "star",
    iconClasses:
      "block w-[28px] h-[28px] bg-black dark:bg-white mr-2 mask-[url(/assets/images/icons/star.svg)] mask-size-[28px_28px]",
  },
];

export const DESKTOP_SECONDARY_NAV_ITEMS: ReadonlyArray<NavigationItem> = [
  {
    labelKey: "COLLECTIONS",
    route: "/collections",
    icon: "lists",
    iconClasses:
      "block w-[28px] h-[28px] bg-black dark:bg-white mr-2 mask-[url(/assets/images/icons/lists.svg)] mask-size-[28px_28px]",
  },
  {
    labelKey: "MY_FRIENDS",
    route: "/friends",
    icon: "collaborators",
    iconClasses:
      "block w-[28px] h-[28px] bg-black dark:bg-white mr-2 mask-[url(/assets/images/icons/collaborators.svg)] mask-size-[28px_28px]",
  },
  {
    labelKey: "STATS",
    route: "/stats",
    icon: "stats",
    iconClasses:
      "block w-[28px] h-[28px] bg-black dark:bg-white mr-2 mask-[url(/assets/images/icons/stats.svg)] mask-size-[28px_28px]",
  },
];

export const MOBILE_EXPLORER_NAV_ITEMS: ReadonlyArray<NavigationItem> = [
  {
    labelKey: "MY_WORKS",
    route: "/history",
    icon: "works",
    iconClasses:
      "block w-[26px] h-[26px] mr-[20px] bg-black dark:bg-white mask-[url(/assets/images/icons/works.svg)] mask-size-[26px_26px]",
  },
  {
    labelKey: "UPCOMING_RELEASES_MENU",
    route: "/upcoming-releases",
    icon: "calendar",
    iconClasses:
      "block w-[26px] h-[26px] mr-[20px] bg-black dark:bg-white mask-[url(/assets/images/icons/calendar.svg)] mask-size-[26px_26px]",
  },
  {
    labelKey: "LATEST_RELEASES",
    route: "/latest-releases",
    icon: "star",
    iconClasses:
      "block w-[26px] h-[26px] mr-[20px] bg-black dark:bg-white mask-[url(/assets/images/icons/star.svg)] mask-size-[26px_26px]",
  },
  {
    labelKey: "MY_FRIENDS",
    route: "/friends",
    icon: "collaborators",
    iconClasses:
      "block w-[26px] h-[26px] mr-[20px] bg-black dark:bg-white mask-[url(/assets/images/icons/collaborators.svg)] mask-size-[26px_26px]",
  },
  {
    labelKey: "STATS",
    route: "/stats",
    icon: "stats",
    iconClasses:
      "block w-[26px] h-[26px] mr-[20px] bg-black dark:bg-white mask-[url(/assets/images/icons/stats.svg)] mask-size-[26px_26px]",
  },
];

export const MOBILE_EXPLORER_ACTIVE_PREFIXES: ReadonlyArray<string> = [
  "/history",
  "/upcoming-releases",
  "/latest-releases",
  "/friends",
  "/stats",
  "/works",
];

export const LISTS_ACTIVE_PREFIXES: ReadonlyArray<string> = [
  "/collections",
  "/ongoing",
  "/followed-works",
  "/recommendations",
];
